module.exports = "# Sizzle\n\n## Content\n\n### Activité 1 : Bricolages d’Esmeralda et de Goober!\n\n## Notes\n\nLes prix de bricolage se trouvent dans la section du matériel à imprimer de la page du tableau de bord.\n\nImprimez les bricolages en couleur ou demandez aux enfants de colorier les leurs après que vous aurez imprimé les versions en noir et blanc!\n\n\n# Intro Video\n\nYouTube: 1Kx_8aYA2A0\n\n## Notes\nIntroduction à l’activité des bricolages (0:29).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/sections/30_classActivity/level6_papercrafts.fr_CA.md
// module id = 1802
// module chunks = 2